// Convert from YYYY-MM-DD  to YYYYMMDD
export const formatDateToCompact = (date: string): string => {
  return date.replace(/-/g, "");
}